export default {
  title: 'Testdoelgroep',
  columns: {
    id: 'Id',
    phone_number: 'Telefoonnummer',
  },
  filters: {
    search: {
      placeholder: 'Zoeken',
    },
  },
  buttons: {
    send_test: 'Test verzenden',
  },
  feedback: {
    success: 'Succesvol verzonden',
    error: 'Verzenden mislukt',
  },
};
